<template>
  <div class="wrap">
    <div id="map"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import 'echarts/map/js/china'
import { listMap } from '@/api'
import double_right_png from '../../assets/images/double_right.png'
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.initMap()
  },
  methods: {
    async getData () {
      const res = await listMap({ useFlag: '1' })
      const list = []
      res.rows.forEach((v, i) => {
        list.push({ ...res.rows[i], value: [v.longitudeLatitude.split(',')[0], v.longitudeLatitude.split(',')[1]] })
      })
      this.list = list
      this.initMap()
    },
    initMap () {
      //初始化echarts实例 通过传参获取要放置的id名称
      const myChart = echarts.init(document.getElementById("map"));
      setTimeout(() => {
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0, // 针对series下第几个数据
          dataIndex: 0 // 第几个数据
        })
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0, // 针对series下第几个数据
          dataIndex: 0 // 第几个数据
        })
      }, 1000)

      // 指定图表的配置项和数据
      const optionMap = {
        //设置 背景颜色
        backgroundColor: "#FFFFFF",
        //配置属性
        geo: {
          map: 'china',
          silent: true, // 禁止图形响应鼠标事件
          zoom: 1.2,
          itemStyle: {
            color: '#fff',   // 背景颜色
            // emphasis: {
            //   borderColor: '#bf2a35',  // 边框颜色
            //   areaColor: '#ffcdcd',    //  区域颜色
            //   borderWidth: 2
            // }
          },
          regions: [{
            name: this.list.length && (this.list[0].city || this.list[0].address.slice(0, 2)),
            itemStyle: {
              borderColor: '#bf2a35',  // 边框颜色
              areaColor: '#ffcdcd',    //  区域颜色
              borderWidth: 2
            }
          }]
        },
        series: [
          {
            type: 'effectScatter',   //  指明图表类型：带涟漪效果的散点图
            coordinateSystem: 'geo', //  指明绘制在geo坐标系上
            data: this.list
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.5)',	//tooltip背景色
          borderColor: '#ffcdcd',		//tooltip边框颜色
          borderWidth: 1,

          alwaysShowContent: true,
          enterable: true,
          formatter: function (params) {
            const data = params.data
            const text = `
            <div class='tooltip'>
              <a class='wrap' href='${data.jump == '1' ? '/SolutionDetails?id=' + data.caseId : 'javascript:void(0)'}' >
                  <div class='title'>${data.name} ${data.jump == '1' ? ('<img src="' + double_right_png + '"/>') : ''}</div>
                  <div class='content'>${data.content}</div>
              </a>
            </div>
            `
            return text;
          }
        },

      };
      //使用制定的配置项和数据显示图表
      myChart.setOption(optionMap);
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .tooltip {
  cursor: pointer;
  padding: 5px;

  .wrap {
    color: #000;
    text-decoration: none;

  }

  .title {
    color: #bf2a35;
    text-align: left;
    margin-bottom: 4px;
    font-weight: 700;
    font-size: 12px;
    display: flex;
    align-items: center;

    img {
      width: 14px;
      margin-left: 4px;
    }
  }

  .content {
    max-width: 250px;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    text-align: left;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box; //弹性盒模型
    -webkit-box-orient: vertical; //上下垂直
    -webkit-line-clamp: 3;
  }
}

#map {
  width: 100%;
  height: 600px;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/mapView/MapView.vue